import React, { Component } from "react";
import ProductListing from './ProductListing';
import '../assets/css/font-awesome.min.css';
import '../assets/fonts/fonts.css';
import './Custom.css';

class Unreleased extends Component {
    render() {
        return (
            <div className="page-unreleased">
                <div className="container">
                    <div className="row releasedate-blk">
                        <div className="pad-50-blk">
                            <ProductListing searchFilter={false} title={'Unreleased'} most_views='' most_likes='' unreleased='1' />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Unreleased;